"use strict"

import {observable, action} from "mobx"
import {v4 as uuidv4} from "uuid"
import RequestFormStore from "./RequestFormStore"
import GlobalStore from "../../global/store/GlobalStore"
import api from "../../global/actions/api"
import {getFilters} from "../../global/helpers/api"

class DeviceDialogStore {
	@observable isOpen = false
	@observable places = []
	@observable onlyDevice = false
	@observable dropdownDevices = []

	formRef = null

	@action open(place) {
		if (place) {
			this.onlyDevice = true
			this.formRef.$("cityName").value = place.city
			this.formRef.$("cityId").value = place.cityId
			this.formRef.$("street").value = place.street
		} else {
			this.onlyDevice = false
		}

		this.loadDropdownDevices()
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}

	@action addDevice(form) {
		const values = form.values()

		if (this.places.length === 0) {
			this.places = [
				{
					cityId: values.cityId,
					city: values.cityName,
					street: values.street,
					devices: [
						{
							_id: uuidv4(),
							deviceId: values.device,
							device: values.deviceName,
							deviceCode: values.deviceCode,
							power: values.devicePower,
							capacity: values.deviceCapacity,
							catastral: values.deviceCadastralArea,
							parcel: values.deviceParcelNumber
						}
					]
				}
			]
		} else {
			const currPlace = this.places.find(
				(place) => place.cityId === values.cityId && place.street === (values.street || "").trim()
			)

			if (currPlace) {
				currPlace.devices.push({
					_id: uuidv4(),
					deviceId: values.device,
					device: values.deviceName,
					deviceCode: values.deviceCode,
					power: values.devicePower,
					capacity: values.deviceCapacity,
					catastral: values.deviceCadastralArea,
					parcel: values.deviceParcelNumber
				})

				const otherPlaces = this.places.filter(
					(place) => place.cityId !== values.cityId || place.street !== (values.street || "").trim()
				)

				otherPlaces.push(currPlace)

				this.places = otherPlaces
			} else {
				this.places.push({
					cityId: values.cityId,
					city: values.cityName,
					street: values.street,
					devices: [
						{
							_id: uuidv4(),
							deviceId: values.device,
							device: values.deviceName,
							deviceCode: values.deviceCode,
							power: values.devicePower,
							capacity: values.deviceCapacity,
							catastral: values.deviceCadastralArea,
							parcel: values.deviceParcelNumber
						}
					]
				})
			}
		}

		this.getAssumedValue()

		form.reset()

		this.close()
	}

	@action removePlace(place) {
		this.places = this.places.filter((pls) => pls.cityId !== place.cityId || pls.street !== (place.street || "").trim())

		this.getAssumedValue()
	}

	@action removeDevice(place, device) {
		this.places = this.places.map((pls) => {
			if (pls.cityId !== place.cityId && pls.street !== (place.street || "").trim()) {
				return pls
			} else {
				const newDevices = pls.devices.filter((dev) => dev._id !== device._id)

				return {
					city: place.city,
					cityId: place.cityId,
					street: place.street,
					devices: newDevices
				}
			}
		})

		this.getAssumedValue()
	}

	@action getAssumedValue() {
		let assumeValue = 0

		this.places.forEach((place) => {
			place.devices.forEach((device) => {
				const power = +device.power.replace(",", ".")

				const deviceCL = GlobalStore.CL["device"].find((x) => x.code === device.deviceCode)
				const deviceUnitPrice =
					isSafe(deviceCL) && isNotEmpty(deviceCL.power_unit_price) ? deviceCL.power_unit_price : 0

				assumeValue += power * deviceUnitPrice

				// switch (device.deviceCode) {
				// 	case "PVNA": // Fotovoltický panel bez akumulácie
				// 		assumeValue += power * 1100
				// 		break
				// 	case "PVWA": // Fotovoltický panel s akumuláciou
				// 		assumeValue += power * 1800
				// 		break
				// 	case "SCWA": // Slnečný kolektor s akumuláciou
				// 		assumeValue += power * 1100
				// 		break
				// 	case "HPWA": // Tepelné čerpadlo s akumuláciou
				// 		assumeValue += power * 1200
				// 		break
				// 	case "HPNA": // Tepelné čerpadlo bez akumulácie
				// 		assumeValue += power * 1000
				// 		break
				// 	case "WTWA": // Veterná turbína s akumuláciou
				// 		assumeValue += power * 2200
				// 		break
				// 	case "WTNA": // Veterná turbína bez akumulácie
				// 		assumeValue += power * 1500
				// 		break
				// }
			})
		})

		let assumedValue = Math.floor(assumeValue * 0.45)

		if (RequestFormStore.formRef.$("contributionForEnergyAudit").value) {
			assumedValue += 2500
		}

		RequestFormStore.formRef.$("expected_voucher_amount").value = assumedValue <= 50000 ? assumedValue : 50000
	}

	@action loadDropdownDevices() {
		const req = getFilters([`round_id=${RequestFormStore.formRef.$("round_id").value}`])

		api
			.loadDevice(req)
			.call()
			.then((res) => {
				if (isNotEmpty(res.rows) && res.rows.length > 0) {
					this.dropdownDevices = res.rows
				} else {
					this.dropdownDevices = []
				}
			})
			.catch(() => {
				this.dropdownDevices = []
			})
	}
}

var singleton = new DeviceDialogStore()
export default singleton

